import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { restartableTask } from 'ember-concurrency';
import FeaturesService from 'ember-feature-flags/services/features';
import ObjectModel from 'cio/models/object';
import DS from 'ember-data';
import { computed } from '@ember/object';
import ApiService from 'cio/services/api';
import { isObjectAttributeIdentifier } from 'cio/utils/identifiers';
import ObjectTypeModel from 'cio/models/object-type';
import ObjectTypesService from 'cio/services/object-types';
import config from 'cio/config/environment';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';

const ENABLE_SEARCH_AFTER = 10;

export default class IndexController extends Controller {
  @service features!: FeaturesService;
  @service store!: DS.Store;
  @service api!: ApiService;
  @service objectTypes!: ObjectTypesService;

  @tracked reloadingRelationshipTable = false;

  declare model: ObjectModel;

  searchTerm = '';

  get searchEnabled() {
    return this.model?.filteredAttrsWithIdentifiers.length >= ENABLE_SEARCH_AFTER;
  }

  @computed('model.filteredAttrsWithIdentifiers.[]', 'searchTerm')
  get matchedAttrs() {
    let trimmedSearchTerm = this.searchTerm.trim();
    let identifiers: Record<string, string>[] = [];
    let attributes: Record<string, string>[] = [];

    this.model.filteredAttrsWithIdentifiers.forEach((attr: Record<string, string>) => {
      let [key] = Object.keys(attr);

      if (trimmedSearchTerm && !key.includes(trimmedSearchTerm)) {
        return;
      }

      if (isObjectAttributeIdentifier(key)) {
        identifiers.push(attr);
      } else {
        attributes.push(attr);
      }
    });

    return {
      identifiers,
      attributes,
      attrsLength: identifiers.length + attributes.length,
    };
  }

  get objectType() {
    return this.model.belongsTo('objectType').value() as ObjectTypeModel;
  }

  fetchLogs = restartableTask(async () => {
    return await this.model.queryLogs({ limit: 5 });
  });

  reloadRelationshipsTable() {
    this.reloadingRelationshipTable = true;
    later(() => {
      this.reloadingRelationshipTable = false;
    }, config.APP.relationshipsChangedDelay);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'object.index': IndexController;
  }
}
